import * as React from "react";
const SvgSdCard = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.744 1.871V22.13H20.246V7.934l-3.031-3.032-3.031-3.03H8.963ZM5.25 3.38H13.568l2.59 2.59 2.59 2.59V20.62H5.25V12Zm2.248 2.055v3.754h1.506V7.316c0-1.028-.002-1.873-.006-1.877a23.682 23.682 0 0 0-.754-.005zm3.752 0v3.754h1.498V5.434H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSdCard;
